import { Button, IconCheck } from '@montel/montelpro-shared-components-v2';
import { MontelAccount } from 'domain/account/interfaces';
import { ProductRegistration } from 'domain/product/interfaces';
import { styled } from 'styled-components';
import { ConditionallyDisabled } from 'components/common/ConditionallyDisabled/ConditionallyDisabled';

interface MarkReviewedProps {
	productRegistration: ProductRegistration | undefined;
	account: MontelAccount;
	onClickReview: (account: MontelAccount) => void;
}

const ButtonWithSlightlySmallerIcon = styled(Button)`
	svg {
		width: 12px;
	}
`;

export const MarkReviewedButton: React.FunctionComponent<MarkReviewedProps> = ({
	productRegistration,
	account,
	onClickReview,
}) => {
	if (!productRegistration) return <></>;

	const onClickHandler = async (
		event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
	) => {
		event.stopPropagation();
		event.preventDefault();

		onClickReview(account);
	};

	return (
		<>
			{productRegistration.reviewed ? null : (
				<ConditionallyDisabled
					disableIf={!account.email.verified}
					tooltip="You cannot review this account until their email address has been verified."
				>
					<ButtonWithSlightlySmallerIcon
						text="Review"
						size="sm"
						variant="primary"
						leftIcon={<IconCheck />}
						onClick={async (
							event: React.MouseEvent<
								HTMLButtonElement,
								MouseEvent
							>,
						) => onClickHandler(event)}
					/>
				</ConditionallyDisabled>
			)}
		</>
	);
};
